<template>
  <div class="health-question-form-container">
    <Panel class="" title="1. ข้อแถลงสุขภาพของผู้ขอเอาประกันภัย">
      <div class="title-text">
        ในกรณีที่ท่านไม่ได้แถลง หรือแถลงไม่ครบถ้วนในข้อใดข้อหนึ่ง บริษัทจะถือเสมือนหนึ่งว่า
        ท่านแถลงปฏิเสธ (ไม่ใช่) ในข้อนั้นๆ
      </div>
      <div class="question-section">
        <div class="question-card">
          <div class="question-text">
            1. ท่านมีประกันชีวิต ประกันภัยสุขภาพ ประกันภัยโรคร้ายแรง โรคมะเร็ง
            หรือประกันภัยอุบัติเหตุ กับบริษัท ประกันภัยไทยวิวัฒน์ หรือบริษัทอื่นหรือไม่?
          </div>
          <div class="question-form">
            <div class="question-radio-container">
              <Radio
                name="healthQuestion1"
                label="1"
                v-model="healthQuestion.q1"
                :disabled="isDisabledForm"
              >
                ใช่
              </Radio>
            </div>
            <div class="question-radio-container">
              <Radio
                name="healthQuestion1"
                label="0"
                v-model="healthQuestion.q1"
                :disabled="isDisabledForm"
              >
                ไม่ใช่
              </Radio>
            </div>
          </div>
          <div class="error-text-section" v-if="applicationValidationErrors.has('q1')">
            {{ healthQuestionErrorMessage }}
          </div>
        </div>
        <div class="question-card">
          <div class="question-text">
            2. ท่านเคยถูกปฏิเสธการขอเอาประกันชีวิต ประกันสุขภาพ ประกันภัยโรคร้ายแรง
            ประกันภัยอุบัติเหตุส่วนบุคคล หรือถูกปฏิเสธการต่ออายุสัญญาประกันภัย
            หรือถูกเรียกเก็บเบี้ยประกันภัยเพิ่ม หรือเปลี่ยนแปลงเงื่อนไข
            สำหรับการประกันภัยดังกล่าวหรือไม่
          </div>
          <div class="question-form">
            <div class="question-radio-container">
              <Radio
                name="healthQuestion2"
                label="1"
                v-model="healthQuestion.q2"
                :disabled="isDisabledForm"
              >
                ใช่
              </Radio>
            </div>
            <div class="question-radio-container">
              <Radio
                name="healthQuestion2"
                label="0"
                v-model="healthQuestion.q2"
                :disabled="isDisabledForm"
              >
                ไม่ใช่
              </Radio>
            </div>
          </div>
          <div class="error-text-section" v-if="applicationValidationErrors.has('q2')">
            {{ healthQuestionErrorMessage }}
          </div>
        </div>
        <div class="question-card">
          <div class="question-text">
            3.ท่านเคยได้รับเชื้อ หรือมีอาการ หรือเคยได้รับการรักษา หรือขณะนี้รับการรักษาอยู่
            หรือเคยได้รับการบอกเล่า จากแพทย์ด้วยโรคมะเร็ง เนื้องอกโรคสมอง/หลอดเลือดสมอง (Stoke)
            โรคตับ โรคเอดส์หรือมีเลือดบวกต่อไวรัส HIV โรคเบาหวาน โรคไต โรคหัวใจ/หลอดเลือด
            ความดันโลหิตสูง ไขมันในเลือดสูง โรคปอด โรคเลือด โรคถุงลม โป่งพอง ลำไส้อักเสบเรื้อรัง
            โรคทางระบบประสาท อัมพาต โรคกระดูกกระดูกสันหลัง โรคกล้ามเนื้อหรือโรคประจำตัว
            หรือมีความพิการ หรือโรคร้ายแรงอื่นๆ (รวมถึงการได้รับการรักษาแบบผู้ป่วยนอก)
          </div>
          <div class="question-form">
            <div class="question-radio-container">
              <Radio
                name="healthQuestion3"
                label="1"
                v-model="healthQuestion.q3"
                :disabled="isDisabledForm"
              >
                ใช่
              </Radio>
            </div>
            <div class="question-radio-container">
              <Radio
                name="healthQuestion3"
                label="0"
                v-model="healthQuestion.q3"
                :disabled="isDisabledForm"
              >
                ไม่ใช่
              </Radio>
            </div>
          </div>
          <div class="error-text-section" v-if="applicationValidationErrors.has('q3')">
            {{ healthQuestionErrorMessage }}
          </div>
        </div>
        <div class="question-card">
          <div class="question-text">
            4.ท่านเคยได้รับคำแนะนำจากแพทย์ให้เข้ารับการรักษาจากการบาดเจ็บ การเจ็บป่วย
            หรือเข้ารับการผ่าตัด หรือมีโรคที่ ต้องอยู่ในความดูแลเป็นประจำของแพทย์
            หรือเข้ารับการตรวจวินิจฉัยโรค เช่น การอัลตร้าซาวด์ เอ็กซเรย์ คอมพิวเตอร์
            การตรวจด้วยคลื่นแม่เหล็กไฟฟ้า การส่งตรวจชิ้นเนื้อทางด้านพยาธิวิทยา การตรวจคลื่นหัวใจ
            การตรวจเลือด ตรวจปัสสาวะ/อุจจาระ หรือไม่ (รวมถึงการได้รับการรักษาแบบผู้ป่วยนอก)
          </div>
          <div class="question-form">
            <div class="question-radio-container">
              <Radio
                name="healthQuestion4"
                label="1"
                v-model="healthQuestion.q4"
                :disabled="isDisabledForm"
              >
                ใช่
              </Radio>
            </div>
            <div class="question-radio-container">
              <Radio
                name="healthQuestion4"
                label="0"
                v-model="healthQuestion.q4"
                :disabled="isDisabledForm"
              >
                ไม่ใช่
              </Radio>
            </div>
          </div>
          <div class="error-text-section" v-if="applicationValidationErrors.has('q4')">
            {{ healthQuestionErrorMessage }}
          </div>
        </div>
        <div class="question-card">
          <div class="question-text">
            5.บิดา มารดา และ/หรือพี่น้อง ของผู้ขอเอาประกันภัยเคยได้รับการวินิจฉัยว่าป่วยเป็น
            หรือเสียชีวิตเนื่องจาก โรคหัวใจ/หลอดเลือด โรคมะเร็ง โรคสมอง/หลอดเลือดสมอง (Stroke)
            โรคตับ โรคเอดส์ วัณโรคหรือไม่?
          </div>
          <div class="question-form">
            <div class="question-radio-container">
              <Radio
                name="healthQuestion5"
                label="1"
                v-model="healthQuestion.q5"
                :disabled="isDisabledForm"
              >
                ใช่
              </Radio>
            </div>
            <div class="question-radio-container">
              <Radio
                name="healthQuestion5"
                label="0"
                v-model="healthQuestion.q5"
                :disabled="isDisabledForm"
              >
                ไม่ใช่
              </Radio>
            </div>
          </div>
          <div class="error-text-section" v-if="applicationValidationErrors.has('q5')">
            {{ healthQuestionErrorMessage }}
          </div>
        </div>
      </div>
      <div class="health-question-decision-error" v-if="isValidated && !isPassValidate">
        **ไม่สามารถทำประกันได้เนื่องจากท่านไม่ผ่านการตอบคำถามสุขภาพ**
      </div>
    </Panel>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import _ from 'lodash'

import Panel from '@/components/Panel'
import Radio from '@/components/Radio'
import { validationRule } from '@/lib/global'

const { mapFields: mapApplicationFields } = createHelpers({
  getterType: 'getApplicationFields',
  mutationType: 'updateApplicationFields',
})

export default {
  name: 'HealthQuestionForm',
  data: () => ({
    healthQuestionErrorMessage: 'กรุณากรอกข้อมูลคำถามสุขภาพให้ครบถ้วน... **',
  }),
  watch: {
    healthQuestion: {
      deep: true,
      handler(val) {
        const convertToList = _.values(val)
        const isAnswerAll = !convertToList.includes(null)
        if (isAnswerAll) {
          const theRestAnswer = _.takeRight(convertToList, 4)
          this.isValidated = true
          this.isPassValidate = _.every(theRestAnswer, val => val === '0')

          if (this.isPassValidate) {
            this.$swal({
              type: 'success',
              title: 'ผ่านการตรวจสอบเกณฑ์การทำกรมธรรม์ประกันภัย',
            })
          } else {
            this.$swal({
              type: 'error',
              title: 'ไม่ผ่านการตรวจสอบเกณฑ์การทำกรมธรรม์ประกันภัย',
            })
          }
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      isDisabledForm: 'isDisabledApplicationForm',
      applicationValidationErrors: 'applicationValidationErrors',
    }),
    ...mapApplicationFields({
      healthQuestion: 'data.healthQuestion.question',
      isValidated: 'data.healthQuestion.isValidated',
      isPassValidate: 'data.healthQuestion.isPassValidate',
    }),
  },
  components: {
    Panel,
    Radio,
  },
}
</script>

<style lang="scss">
.health-question-form-container {
  .title-text {
    font-family: 'psl_kanda_extraregular' !important;
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 16px;
  }

  .question-section {
    .question-card {
      &:not(:first-child) {
        margin-top: 24px;
      }

      &:not(:last-child) {
        border-bottom: 1px dashed #cccccc;
        padding-bottom: 24px;
      }

      .question-text {
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 12px;
      }

      .question-form {
        text-align: center;

        .question-radio-container {
          display: inline-block;
          margin-right: 40px;
        }
      }

      .error-text-section {
        color: #e40000;
        font-size: 12px;
        line-height: 16px;
      }
    }
  }

  .health-question-decision-error {
    color: #e40000;
    font-size: 12px;
    line-height: 16px;
    margin-top: 24px;
  }
}
</style>
